import Vue from 'vue';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import store from '@/core/store';
import eventbus from '@/core/shared/services/EventBus';

if (
  window.sbvrenv.NODE_ENV !== 'development' &&
  process.env.NODE_ENV === 'production'
) {
  Sentry.init({
    dsn: 'https://4e693514a64344c6896b9258d2c10c2f@sentry.io/271924',
    integrations: [
      new Integrations.Dedupe(),
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
    captureUnhandledRejections: false,
    environment: window.sbvrenv.NODE_ENV,
    debug: true,
  });
  Sentry.configureScope(scope => {
    scope.setTag('git_commit', COMMITHASH);
    if (window.sbvrenv.TRANSACTION_ID) {
      scope.setTag('transaction_id', window.sbvrenv.TRANSACTION_ID);
    }
    Sentry.setExtra('initial_href', window.location.href);
  });
  Sentry.addBreadcrumb({
    category: 'location',
    message: 'initial href: ' + window.location.href,
  })
  ;(function setupOrganizationScopeWatcher () {
    const unsub = store.watch(
      (state, { currentStation }) =>
        currentStation && currentStation.organization,
      val => {
        if (val) {
          const { id, name: username } = val;
          Sentry.configureScope(scope => {
            scope.setUser({
              id,
              username,
            });
            const { title } = store.getters.currentStation;
            scope.setExtra('station_title', title);
          });
          unsub();
        }
      },
    );
  })()
  ;(function setupStationIdScopeWatcher () {
    const unsub = store.watch(
      (state, { stationId }) => stationId,
      val => {
        if (val) {
          Sentry.configureScope(scope => {
            scope.setTag('station_id', val);
          });
          unsub();
        }
      },
    );
  })();
  eventbus.$on('interop', ({ type, name, payload }) => {
    let payloadFormatted;
    try {
      payloadFormatted = JSON.stringify(payload);
    } catch (e) {
      payloadFormatted = payload;
    }
    Sentry.addBreadcrumb({
      message: `Interop ${type}: ${name}`,
      category: 'action',
      level: Sentry.Severity.Info,
      data: {
        payload: payloadFormatted,
      },
    });
  });
  eventbus.$on('safety-mode:activate', () => {
    Sentry.captureMessage('Safety mode on');
  });
  eventbus.$on('sentry:captureException', e => {
    Sentry.captureException(e);
  });
  eventbus.$on('sentry:captureMessage', msg => {
    Sentry.captureMessage(msg);
  });
  eventbus.$on('sentry:addBreadcrumb', payload => {
    Sentry.addBreadcrumb(payload);
  });

  const captureError = event => {
    const error = event.reason;
    function isErrorOrErrorEvent (e) {
      return (
        e instanceof Error ||
        Object.prototype.toString.call(e) === '[object Error]' ||
        Object.prototype.toString.call(e) === '[object ErrorEvent]'
      );
    }
    if (isErrorOrErrorEvent(error)) {
      Sentry.captureException(error.originalError || error);
    } else {
      Sentry.captureMessage(error.error || error);
    }
  };
  window.onunhandledrejection = captureError;
  window.addEventListener('unhandledrejection', captureError);
}
